import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  saveSearchAssistDetails,
  saveSearchDetails,
  setSearchFlights,
} from '@shared/redux/actions';

const useRestoreSearchFromStorage = () => {
  const dispatch = useDispatch();
  const [restored, setRestored] = useState(false);

  useEffect(() => {
    const storageHandlers = {
      'search-hotel': data => {
        dispatch(
          saveSearchDetails({ ...data.infoSearch, searchId: Date.now() })
        );
      },
      'search-assist': data => {
        dispatch(saveSearchAssistDetails(data.infoSearch));
      },
      'search-flights': data => {
        if (data.infoSearch) {
          dispatch(setSearchFlights(data.infoSearch));
        }
      },
    };

    Object.entries(storageHandlers).forEach(([key, handler]) => {
      const raw = localStorage.getItem(key);
      if (!raw) return;

      try {
        const data = JSON.parse(raw);
        handler(data);
      } catch (error) {
        console.error(
          `[useRestoreSearchFromStorage] Error al parsear ${key}:`,
          error
        );
      } finally {
        localStorage.removeItem(key);
      }
    });

    setRestored(true);
  }, [dispatch]);

  return restored;
};

export default useRestoreSearchFromStorage;
